import { render, staticRenderFns } from "./UnderlayNoise.vue?vue&type=template&id=2fc2e335&"
import script from "./UnderlayNoise.vue?vue&type=script&lang=js&"
export * from "./UnderlayNoise.vue?vue&type=script&lang=js&"
import style0 from "./UnderlayNoise.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports